import React, { useState } from "react";
import { useDispatch, useSelector } from "types/store";
import { Button } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import styles from "./style.module.css";
import * as nextReducer from "containers/Next/NextReducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import { updateChatGPTFieldValue, saveReport } from "containers/Report/ReportReducer";
const KPIMetricsLabels = (props) => {
    const dispatch = useDispatch();
    const [hasChangedReport, setHasChangedReport] = useState(false);
    const [isSavingReport, setIsSavingReport] = useState(false);
    const id = props.id;
    const nextId = useSelector((state) => id ?? nextReducer.getCurrentNextId(state));
    const comparisonOptions = useSelector((state) => nextReducer.getComparisonOptions(state, nextId));
    const reportIdOverride = props.useReportIdForChatGPTReducer && !isNaN(Number(id)) ? Number(id) : undefined;
    // The user has edited the values in a report not the chatgptreducer so we need to save the report to save the values
    const shouldShowReportSaveButton = props.useReportIdForChatGPTReducer && reportIdOverride !== undefined && hasChangedReport;
    const hideMissingInCharts = useSelector((state) => props.hideMissingInCharts ?? chatGPTReducer.getHideMissingInCharts(state, undefined, undefined, reportIdOverride));
    const hideOtherInCharts = useSelector((state) => props.hideOtherInCharts ?? chatGPTReducer.getHideOtherInCharts(state, undefined, undefined, reportIdOverride));
    const hideChangeInBehavior = useSelector((state) => props.hideChangeInBehavior ??
        chatGPTReducer.getHideChangeInBehavior(state, undefined, undefined, reportIdOverride));
    const hideChangeInPopulation = useSelector((state) => props.hideChangeInPopulation ??
        chatGPTReducer.getHideChangeInPopulation(state, undefined, undefined, reportIdOverride));
    const hideChangeInOutcome = useSelector((state) => props.hideChangeInOutcome ?? chatGPTReducer.getHideChangeInOutcome(state, undefined, undefined, reportIdOverride));
    const hideChangeInTotalPopulation = useSelector((state) => props.hideChangeInTotalPopulation ??
        chatGPTReducer.getHideChangeInTotalPopulation(state, undefined, undefined, reportIdOverride));
    const renameBehavior = useSelector((state) => props.renameBehavior ?? chatGPTReducer.getRenameBehavior(state, undefined, undefined, reportIdOverride));
    const renameOutcome = useSelector((state) => props.renameOutcome ?? chatGPTReducer.getRenameOutcome(state, undefined, undefined, reportIdOverride));
    const renamePopulation = useSelector((state) => props.renamePopulation ?? chatGPTReducer.getRenamePopulation(state, undefined, undefined, reportIdOverride));
    const renameTotalPopulation = useSelector((state) => props.renameTotalPopulation ??
        chatGPTReducer.getRenameTotalPopulation(state, undefined, undefined, reportIdOverride));
    if (!comparisonOptions?.dateField) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: styles.filterStats },
        React.createElement("div", { className: styles.filterStatLabel }, "Percent Change in Behavior"),
        React.createElement("div", { className: styles.filterStat },
            React.createElement("input", { type: "checkbox", className: styles.filterStatCheckbox, checked: !hideChangeInBehavior, onClick: () => {
                    if (props.updateHideChangeInBehavior) {
                        return props.updateHideChangeInBehavior(!hideChangeInBehavior);
                    }
                    if (props.useReportIdForChatGPTReducer) {
                        setHasChangedReport(true);
                        return dispatch(updateChatGPTFieldValue(id, "hideChangeInBehavior", !hideChangeInBehavior));
                    }
                    return dispatch(chatGPTReducer.updateHideChangeInBehavior(!hideChangeInBehavior));
                } }),
            React.createElement("span", { className: styles.filterStatText }, "Change in "),
            React.createElement(LineInput, { value: renameBehavior, onChange: (val) => {
                    if (props.updateRenameBehavior) {
                        return props.updateRenameBehavior(val);
                    }
                    if (props.useReportIdForChatGPTReducer) {
                        setHasChangedReport(true);
                        return dispatch(updateChatGPTFieldValue(id, "renameBehavior", val));
                    }
                    return dispatch(chatGPTReducer.updateRenameBehavior(val));
                } }),
            React.createElement("span", { className: styles.filterStatText }, " %")),
        React.createElement("div", { className: styles.filterStatLabel }, "Percent Change in Count"),
        React.createElement("div", { className: styles.filterStat },
            React.createElement("input", { type: "checkbox", className: styles.filterStatCheckbox, checked: !hideChangeInPopulation, onClick: () => {
                    if (props.updateHideChangeInPopulation) {
                        return props.updateHideChangeInPopulation(!hideChangeInPopulation);
                    }
                    if (props.useReportIdForChatGPTReducer) {
                        setHasChangedReport(true);
                        return dispatch(updateChatGPTFieldValue(id, "hideChangeInPopulation", !hideChangeInPopulation));
                    }
                    return dispatch(chatGPTReducer.updateHideChangeInPopulation(!hideChangeInPopulation));
                } }),
            React.createElement("span", { className: styles.filterStatText }, "Change in "),
            React.createElement(LineInput, { value: renamePopulation, onChange: (val) => {
                    if (props.updateRenamePopulation) {
                        return props.updateRenamePopulation(val);
                    }
                    if (props.useReportIdForChatGPTReducer) {
                        setHasChangedReport(true);
                        return dispatch(updateChatGPTFieldValue(id, "renamePopulation", val));
                    }
                    return dispatch(chatGPTReducer.updateRenamePopulation(val));
                } }),
            React.createElement("span", { className: styles.filterStatText }, " %")),
        React.createElement("div", { className: styles.filterStatLabel }, "Actual Change in KPI"),
        React.createElement("div", { className: styles.filterStat },
            React.createElement("input", { type: "checkbox", className: styles.filterStatCheckbox, checked: !hideChangeInOutcome, onClick: () => {
                    if (props.updateHideChangeInOutcome) {
                        return props.updateHideChangeInOutcome(!hideChangeInOutcome);
                    }
                    if (props.useReportIdForChatGPTReducer) {
                        setHasChangedReport(true);
                        return dispatch(updateChatGPTFieldValue(id, "hideChangeInOutcome", !hideChangeInOutcome));
                    }
                    return dispatch(chatGPTReducer.updateHideChangeInOutcome(!hideChangeInOutcome));
                } }),
            React.createElement("span", { className: styles.filterStatText }, "Change in "),
            React.createElement(LineInput, { value: renameOutcome, onChange: (val) => {
                    if (props.updateRenameOutcome) {
                        return props.updateRenameOutcome(val);
                    }
                    if (props.useReportIdForChatGPTReducer) {
                        setHasChangedReport(true);
                        return dispatch(updateChatGPTFieldValue(id, "renameOutcome", val));
                    }
                    return dispatch(chatGPTReducer.updateRenameOutcome(val));
                } })),
        React.createElement("div", { className: styles.filterStatLabel }, "Actual Count Change"),
        React.createElement("div", { className: styles.filterStat },
            React.createElement("input", { type: "checkbox", className: styles.filterStatCheckbox, checked: !hideChangeInTotalPopulation, onClick: () => {
                    if (props.updateHideChangeInTotalPopulation) {
                        return props.updateHideChangeInTotalPopulation(!hideChangeInTotalPopulation);
                    }
                    if (props.useReportIdForChatGPTReducer) {
                        setHasChangedReport(true);
                        return dispatch(updateChatGPTFieldValue(id, "hideChangeInTotalPopulation", !hideChangeInTotalPopulation));
                    }
                    return dispatch(chatGPTReducer.updateHideChangeInTotalPopulation(!hideChangeInTotalPopulation));
                } }),
            React.createElement("span", { className: styles.filterStatText }, "Change in "),
            React.createElement(LineInput, { value: renameTotalPopulation, onChange: (val) => {
                    if (props.updateRenameTotalPopulation) {
                        return props.updateRenameTotalPopulation(val);
                    }
                    if (props.useReportIdForChatGPTReducer) {
                        setHasChangedReport(true);
                        return dispatch(updateChatGPTFieldValue(id, "renameTotalPopulation", val));
                    }
                    return dispatch(chatGPTReducer.updateRenameTotalPopulation(val));
                } }),
            React.createElement("span", { className: styles.filterStatText }, "(actual)")),
        React.createElement("div", { className: styles.comparisonChartCheckboxWrapper, onClick: () => {
                if (props.updateHideMissingInCharts) {
                    return props.updateHideMissingInCharts(!hideMissingInCharts);
                }
                if (props.useReportIdForChatGPTReducer) {
                    setHasChangedReport(true);
                    return dispatch(updateChatGPTFieldValue(id, "hideMissingInCharts", !hideMissingInCharts));
                }
                return dispatch(chatGPTReducer.updateHideMissingInCharts(!hideMissingInCharts));
            } },
            React.createElement("input", { type: "checkbox", checked: hideMissingInCharts, readOnly: true }),
            "Hide {Missing} Charts"),
        React.createElement("div", { className: styles.comparisonChartCheckboxWrapper, onClick: () => {
                if (props.updateHideOtherInCharts) {
                    return props.updateHideOtherInCharts(!hideOtherInCharts);
                }
                if (props.useReportIdForChatGPTReducer) {
                    setHasChangedReport(true);
                    return dispatch(updateChatGPTFieldValue(id, "hideOtherInCharts", !hideOtherInCharts));
                }
                return dispatch(chatGPTReducer.updateHideOtherInCharts(!hideOtherInCharts));
            } },
            React.createElement("input", { type: "checkbox", checked: hideOtherInCharts, readOnly: true }),
            "Hide {Other} Charts"),
        shouldShowReportSaveButton ? (React.createElement(Button, { type: "primary", isLoading: isSavingReport, onClick: () => {
                setIsSavingReport(true);
                return dispatch(saveReport(reportIdOverride))
                    .then(() => {
                    setHasChangedReport(false);
                })
                    .finally(() => {
                    setIsSavingReport(false);
                });
            } }, "Save Changes")) : null));
};
export default KPIMetricsLabels;
